<template>
  <section>
    <v-dialog v-model="show" fullscreen>
      <v-card flat>
        <v-container style="padding: 24px">
          <div class="dialog-toolbar">
            <v-col cols="9" md="11">
              <h3>Cancelar visita</h3>
            </v-col>
            <v-col cols="1" md="1" class="pull-right">
              <v-icon
                @click="$emit('close-dialog')"
                style="transform: translateX(-15px)"
                >close</v-icon
              >
            </v-col>
          </div>
          <div style="height: 50px"></div>
          <v-row>
            <v-col cols="12" md="6" offset-md="3">
              <v-row>
                <!-- Combobox for mobs users -->
                <v-col v-if="mobsUser" class="pb-0">
                  <v-select
                    label="Motivo de cancelación"
                    :items="reasonItems"
                    outlined
                    flat
                    v-model="reasonSelected"
                    @blur="$v.reasonSelected.$touch()"
                    :error="$v.reasonSelected.$error"
                    :error-messages="reasonErrors"
                    item-text="text"
                    item-value="text"
                  >
                  </v-select>
                </v-col>
                <!-- Text field for normal technician -->
                <v-col v-else cols="12" style="padding-bottom: 0">
                  <v-textarea
                    :rows="1"
                    auto-grow
                    autofocus
                    label="Por favor indique el motivo de cancelación"
                    v-model="cancellationReason"
                    @input="$v.cancellationReason.$touch()"
                    :error="$v.cancellationReason.$error"
                    :error-messages="reasonErrors"
                  />
                </v-col>
                <v-col cols="12">
                  <v-btn color="rapired" dark block @click="save"
                    >CANCELAR VISITA</v-btn
                  >
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </section>
</template>
<script>
import { required } from "vuelidate/lib/validators";

export default {
  name: "finalize-service",
  props: {
    show: Boolean,
    visitId: Number,
  },
  data() {
    return {
      cancellationReason: null,
      reasonSelected: null,
      reasonItems: [
        { id: 1, text: "Por demora" },
        { id: 2, text: "Actividad errónea" },
        { id: 3, text: "Falta de condiciones" },
      ],
    };
  },
  validations() {
    const validations = {
      cancellationReason: { required },
      reasonSelected: { required },
    };
    return validations;
  },
  computed: {
    mobsUser() {
      return this.$store.state.mobsUser;
    },
    reasonErrors: function () {
      const errors = [];
      if (!this.$v.cancellationReason.$error || !this.$v.reasonSelected.$error)
        return errors;
      if (
        !this.$v.cancellationReason.required ||
        !this.$v.reasonSelected.required
      ) {
        errors.push("Este campo es requerido");
      }
      return errors;
    },
  },
  methods: {
    save() {
      this.$v.cancellationReason.$touch();
      if (
        !this.$v.cancellationReason.$error ||
        !this.$v.reasonSelected.$error
      ) {
        const body = this.mobsUser
          ? { id: 16, reason: this.reasonSelected }
          : { id: 4, reason: this.cancellationReason };
        this.axios
          .post(`/visit/${this.visitId}/status/`, body)
          .then((response) => {
            // this.$store.commit("reload_data", true);
            this.$emit("reload-request");
            this.$emit("close-dialog");
            this.$store.commit("show_alert", "La visita ha sido cancelada");
          });
      }
    },
  },
};
</script>
<style scoped>
@media (max-width: 959px) {
}
@media (min-width: 960px) {
  .pull-right {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
